import { ExportTrainingsDataDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ExportTrainings as ExportTrainingsComponent } from 'modules/trainings/components/ExportTrainings'

const ExportTrainings = () => {
  const { data, loading } = useQuery(ExportTrainingsDataDocument)

  const teams = data?.teams.teams

  return <ExportTrainingsComponent loading={loading} teams={teams ?? []} />
}

export default ExportTrainings
